import React from "react";
import { ESTADOS_INV_ALMACEN } from "../../../../../../utility/constants";

// Estado de gestión de un almacén dentro de un inventario. Lo comparten la
// gestión propia y la consulta del inventario de otro acopio
export const EstadoAlmacenInventario = (estado) => {
    const STYLES = {
        success: {
            color: "#3d8d50",
            bg: "#d4edda",
            icon: "✅",
        },
        warning: {
            color: "#856404",
            bg: "#fff3cd",
            icon: "⚠️",
        },
        danger: {
            color: "#dc3545",
            bg: "#f8d7da",
            icon: "❌",
        },
        default: {
            color: "#333",
            bg: "#f0f0f0",
            icon: null,
        },
    };

    const CONFIG = {
        [ESTADOS_INV_ALMACEN.PENDIENTE]: {
            label: "Pendiente",
            type: "danger",
        },
        [ESTADOS_INV_ALMACEN.PENDIENTE_ANALISIS]: {
            label: "Pendiente análisis DRC",
            type: "warning",
        },
        [ESTADOS_INV_ALMACEN.PROCESADO_SOBRANTE]: {
            label: "Procesado con sobrantes",
            type: "success",
        },
        [ESTADOS_INV_ALMACEN.SIN_CAMBIOS]: {
            label: "Sin cambios",
            type: "success",
        },
        [ESTADOS_INV_ALMACEN.CERO]: {
            label: "En cero",
            type: "success",
        },
        // El almacén de reproceso no se gestiona: su inventario sale de lo que
        // recibió menos lo que las tancadas consumieron
        [ESTADOS_INV_ALMACEN.AUTOMATICO]: {
            label: "Automático",
            type: "success",
        },
    };

    const config = CONFIG[estado] || {
        label: "Desconocido",
        type: "default",
    };

    const style = STYLES[config.type];

    return (
        <div
            style={{
                color: style.color,
                backgroundColor: style.bg,
                fontWeight: "bold",
                minWidth: "140px",
                borderRadius: "8px",
                padding: "4px 8px",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
            }}
        >
            <span>
                {style.icon} {config.label}
            </span>
        </div>
    );
};
